var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.chips),function(chip){return _c('v-col',{key:chip.key,attrs:{"cols":"auto"}},[_c('v-chip',{attrs:{"small":""}},[_vm._v(" "+_vm._s(chip.value)+" "+_vm._s(chip.text)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }